import type { Appointment, AppointmentDraft } from '@domain/entities';
import type { AppointmentQuery, AppointmentRepository } from '@domain/repositories';
import type { Page } from '@domain/value-objects';
import type { UseCase } from '../use-case';

export class SearchAppointments implements UseCase<AppointmentQuery, Page<Appointment>> {
  constructor(private readonly repo: AppointmentRepository) {}
  execute(query: AppointmentQuery): Promise<Page<Appointment>> {
    return this.repo.search(query);
  }
}

export class CreateAppointment implements UseCase<AppointmentDraft, Appointment> {
  constructor(private readonly repo: AppointmentRepository) {}
  execute(draft: AppointmentDraft): Promise<Appointment> {
    if (!draft.userId) throw new Error('Utilisatrice requise');
    if (!draft.reason.trim()) throw new Error('Motif requis');
    if (!draft.scheduledAt) throw new Error('Date requise');
    if (!draft.location.trim()) throw new Error('Lieu requis');
    return this.repo.create(draft);
  }
}

export class UpdateAppointment implements UseCase<{ id: string; draft: Omit<AppointmentDraft, 'userId'> }, Appointment> {
  constructor(private readonly repo: AppointmentRepository) {}
  execute({ id, draft }: { id: string; draft: Omit<AppointmentDraft, 'userId'> }): Promise<Appointment> {
    if (!draft.reason.trim()) throw new Error('Motif requis');
    if (!draft.scheduledAt) throw new Error('Date requise');
    if (!draft.location.trim()) throw new Error('Lieu requis');
    return this.repo.update(id, draft);
  }
}

export class DeleteAppointment implements UseCase<string, void> {
  constructor(private readonly repo: AppointmentRepository) {}
  execute(id: string): Promise<void> {
    return this.repo.remove(id);
  }
}
